import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { PageFooterComponent } from './shared/components/page-footer/page-footer.component';
import {
  MatDateFormats,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { filter, map, mergeMap } from 'rxjs';
import { CommonModule } from '@angular/common';

export const CUSTOM_LUXON_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'yyyy/LL/dd',
  },
  display: {
    dateInput: 'yyyy/LL/dd',
    monthYearLabel: 'LLL yyyy',
    dateA11yLabel: 'DDDD',
    monthYearA11yLabel: 'LLLL yyyy',
  },
};

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, PageFooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
    { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_LUXON_DATE_FORMATS },
  ],
})
export class AppComponent implements OnInit {
  title = 'Vanhu Tech';

  layoutClass = 'inner-scroll';

  // MSAL
  isIframe = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let r = this.route;
          while (r.firstChild) r = r.firstChild;
          return r;
        }),
        mergeMap(r => r.data),
      )
      .subscribe(data => {
        this.layoutClass = data['layoutClass'] || 'inner-scroll';
      });

    // // GC: This bit of code is to check what is calling acquireTokenSilent. You'll need to inject MsalService in the constructor to use it.
    //
    // const originalAcquire = this.msalService.instance.acquireTokenSilent.bind(
    //   this.msalService.instance,
    // );

    // this.msalService.instance.acquireTokenSilent = request => {
    //   console.warn('[MSAL Spy] acquireTokenSilent called with:', request);
    //   console.warn(new Error('Stack trace for token request').stack);
    //   return originalAcquire(request);
    // };
  }

  ngOnInit(): void {
    // MSAL
    this.isIframe = window !== window.parent && !window.opener;
  }
}
